export default __webpack_public_path__ + "static/media/master.418295d7.png";